import { SymbolEventColumn } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { GridDetailsPanelColumnDef } from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef';

const tickerChange: GridDetailsPanelColumnDef<SymbolEventColumn>[] = [
    {
        controls: [
            { type: 'field', field: 'oldTicker' },
            { type: 'field', field: 'exDate' },
        ],
    },
    {
        controls: [{ type: 'field', field: 'newTicker' }],
    },
];

export default tickerChange;
